__turbopack_context__.v({
  "New": "desktop-program-module-scss-module__tZ77ga__New",
  "Popular": "desktop-program-module-scss-module__tZ77ga__Popular",
  "activeCategory": "desktop-program-module-scss-module__tZ77ga__activeCategory",
  "arrowContainer": "desktop-program-module-scss-module__tZ77ga__arrowContainer",
  "category": "desktop-program-module-scss-module__tZ77ga__category",
  "categoryTitle": "desktop-program-module-scss-module__tZ77ga__categoryTitle",
  "dNoResults": "desktop-program-module-scss-module__tZ77ga__dNoResults",
  "dProgramClosedSearchWrapper": "desktop-program-module-scss-module__tZ77ga__dProgramClosedSearchWrapper",
  "dProgramCloser": "desktop-program-module-scss-module__tZ77ga__dProgramCloser",
  "dProgramMenu": "desktop-program-module-scss-module__tZ77ga__dProgramMenu",
  "dProgramMenuWrapper": "desktop-program-module-scss-module__tZ77ga__dProgramMenuWrapper",
  "dProgramResultMainContainer": "desktop-program-module-scss-module__tZ77ga__dProgramResultMainContainer",
  "dProgramSearchResults": "desktop-program-module-scss-module__tZ77ga__dProgramSearchResults",
  "dProgramSearchWrapper": "desktop-program-module-scss-module__tZ77ga__dProgramSearchWrapper",
  "dSearchClose": "desktop-program-module-scss-module__tZ77ga__dSearchClose",
  "dSearchIcon": "desktop-program-module-scss-module__tZ77ga__dSearchIcon",
  "dSearchResultItem": "desktop-program-module-scss-module__tZ77ga__dSearchResultItem",
  "exploreCTA": "desktop-program-module-scss-module__tZ77ga__exploreCTA",
  "leftArrow": "desktop-program-module-scss-module__tZ77ga__leftArrow",
  "programHeadTitle": "desktop-program-module-scss-module__tZ77ga__programHeadTitle",
  "programListTitle": "desktop-program-module-scss-module__tZ77ga__programListTitle",
  "programWrapper": "desktop-program-module-scss-module__tZ77ga__programWrapper",
  "programsListingMainContainer": "desktop-program-module-scss-module__tZ77ga__programsListingMainContainer",
  "programsListingWrapper": "desktop-program-module-scss-module__tZ77ga__programsListingWrapper",
  "programsWrapper": "desktop-program-module-scss-module__tZ77ga__programsWrapper",
  "rightArrow": "desktop-program-module-scss-module__tZ77ga__rightArrow",
  "tag": "desktop-program-module-scss-module__tZ77ga__tag",
});
